const moduleConfig = Object.freeze({
  1: [
    {
      id: 'operacionypropiedad',
      stepId: 1,
      enablingStep: 1,
      enablingModule: 0,
      stepName: 'principales',
      title: 'publisher.step1.module1.progressStepName',
      path: '/publicador/principales/operacionypropiedad',
      previousModules: null
    },
    {
      id: 'ubicacion',
      stepId: 1,
      enablingStep: 1,
      enablingModule: 1,
      stepName: 'principales',
      title: 'publisher.step1.module2.progressStepName',
      path: '/publicador/principales/ubicacion',
      previousModules: ['operacionypropiedad']
    },
    {
      id: 'caracteristicas',
      stepId: 1,
      enablingStep: 1,
      enablingModule: 2,
      stepName: 'principales',
      title: 'publisher.step1.module4.progressStepName',
      path: '/publicador/principales/caracteristicas',
      previousModules: ['operacionypropiedad', 'ubicacion']
    }
  ],
  2: null,
  3: null,
  4: [
    {
      id: 'seleccion',
      stepId: 4,
      enablingStep: 3,
      enablingModule: 1,
      stepName: 'planes',
      title: 'publisher.step4.module1.progressStepName',
      path: '/publicador/planes/seleccion',
      previousModules: null
    },
    {
      id: 'pago',
      stepId: 4,
      enablingStep: 4,
      enablingModule: 1,
      stepName: 'planes',
      title: 'publisher.step4.module2.progressStepName',
      path: '/publicador/planes/pago',
      previousModules: ['seleccion']
    },
    {
      id: 'vistaprevia',
      stepId: 4,
      enablingStep: 4,
      enablingModule: 2,
      stepName: 'planes',
      title: 'publisher.step4.module3.progressStepName',
      path: '/publicador/planes/vistaprevia',
      previousModules: ['seleccion', 'pago']
    }
  ]
});

function getProgressBoxConfig(step) {
  return moduleConfig[step] || null;
}

export { getProgressBoxConfig, moduleConfig };
